import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebaseConfig";

import "../styles/corretores.css";

import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

import { IoArrowBackSharp } from "react-icons/io5";


function Corretores() {
  const descricoesCorretores = {
    "Aluizio Senna": `
Corretor de imóveis registrado (CRECI/MG 30.813), atuo no mercado
imobiliário com foco em realizar o sonho da casa própria e
garantir investimentos seguros. Além disso, minha paixão pela
náutica me conecta a um estilo de vida que valoriza lazer e
bem-estar em cenários paradisíacos.

Fundada para oferecer um atendimento personalizado e de
qualidade, a Senna Imóveis busca sempre as melhores oportunidades
para seus clientes. Acredito que, com dedicação e fé, podemos
conquistar nossos objetivos, sempre buscando a excelência em cada
negociação.
`,
    "Vitor Viannini": `
Com 9 anos de experiência no mercado imobiliário, ajudo a
transformar sonhos em realidade e investimentos em patrimônio
sólido. Desde 2014, construí minha carreira com base em confiança,
transparência e dedicação aos clientes.

Corretor registrado (CRECI/MG 31.434), fundei a Senna Viannini para
oferecer um atendimento personalizado e eficiente. Acredito que,
se você pode sonhar, pode conquistar, e estou aqui para guiá-lo
em cada etapa da jornada imobiliária.
`,
    "Ana Laura  Brito Senna": `
Meu nome é Ana Laura Senna, tenho 20 anos e iniciei recentemente
minha trajetória no mercado imobiliário. Estou muito feliz em
trilhar esse caminho, unindo dedicação, disposição e o propósito
de ajudar pessoas a realizarem seus sonhos por meio da compra,
venda ou locação de imóveis.

Como corretora de imóveis, CRECI 62.247, meu compromisso é
oferecer um atendimento atencioso, transparente e totalmente
personalizado, sempre buscando compreender as necessidades de
cada cliente para apresentar as melhores oportunidades.

Seja para conquistar o primeiro lar, investir ou vender um
imóvel, estou à disposição para acompanhar e auxiliar em todas as
etapas desse processo tão importante.
`,
    "Gabriel Viannini": `
Sou Gabriel Viannini Fonseca, corretor de imóveis, e tenho paixão
por ajudar você a encontrar o lar ideal. Com experiência,
dedicação e comprometimento, estou preparado para orientar você
em cada etapa da realização do seu sonho de morar bem.

Como corretor de imóveis, CRECI 58.559, meu compromisso é oferecer
um atendimento transparente, personalizado e de total confiança,
seja para comprar, vender ou investir em imóveis.

Vamos transformar seus planos e sonhos em realidade juntos?
`,
    "José Peixoto": `
Sou José Peixoto, corretor de imóveis, comprometido em transformar
buscas em conquistas. Acredito que cada negociação vai muito além
de apresentar um imóvel: é sobre revelar possibilidades de vida,
realização de sonhos e oportunidades de investimento seguro.

Como corretor de imóveis, CRECI 56.924, meu propósito é oferecer
um atendimento transparente, próximo e dedicado, compreendendo
cada cliente de forma única para entregar soluções
verdadeiramente personalizadas.

Mais do que paredes e estruturas, entrego histórias, confiança e
a certeza de que cada escolha foi feita com cuidado. Conte comigo
para guiá-lo nesse processo e encontrar não apenas um imóvel, mas
o cenário ideal para sua vida ou para seu próximo investimento.
`
  };


  const [corretores, setCorretores] = useState([]);

  useEffect(() => {
    const corretoresRef = ref(db, "corretores");

    onValue(corretoresRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) return;

      const lista = Object.values(data)
        .filter(c => c.creci && c.creci !== "0000")

        .sort((a, b) => {
          const nomeA = `${a.nome} ${a.sobrenome}`;
          const nomeB = `${b.nome} ${b.sobrenome}`;

          if (nomeA === "Aluizio Senna") return -1;
          if (nomeB === "Aluizio Senna") return 1;

          if (nomeA === "Vitor Viannini") return -1;
          if (nomeB === "Vitor Viannini") return 1;

          return nomeA.localeCompare(nomeB, "pt-BR");

        });

      setCorretores(lista);
    });
  }, []);


  const backPage = () => {
    window.history.back();
  };

  return (
    <div className="lancamentosPlanta">
      <div className="titlePageLanc">
        <button onClick={backPage}>
          <IoArrowBackSharp />
        </button>
        <h2>Nossos Corretores</h2>
      </div>

      {corretores.map((corretor) => {
        const nomeCompleto = `${corretor.nome} ${corretor.sobrenome}`;
        const descricao = descricoesCorretores[nomeCompleto];

        return (
          <div className="corretoresContainer" key={corretor.id}>
            <div className="corretoresCard">
              <div className="imgWrapper">
                <img src={corretor.fotoURL} alt={nomeCompleto} />
              </div>

              <div className="infosCorretor">
                <h2>{nomeCompleto}</h2>

                <p>
                  {descricao}
                  <br /><br />
                  <strong>CRECI:</strong> {corretor.creci}
                </p>

                <div className="redesSociais">
                  <a href={corretor.instagram} target="_blank">
                    <FaInstagram />
                  </a>

                  <a
                    href={`https://wa.me/55${corretor.telefone}`}
                    target="_blank"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Corretores;
